// WebAuthn Level 3 JSON helpers: the Foundation sends options as JSON and accepts credential.toJSON().
export async function create(options: PublicKeyCredentialCreationOptionsJSON): Promise<unknown> {
  const publicKey = PublicKeyCredential.parseCreationOptionsFromJSON(options);
  const credential = (await navigator.credentials.create({ publicKey })) as PublicKeyCredential;
  return credential.toJSON();
}

export async function get(options: PublicKeyCredentialRequestOptionsJSON): Promise<unknown> {
  const publicKey = PublicKeyCredential.parseRequestOptionsFromJSON({ ...options, userVerification: "required" });
  const credential = (await navigator.credentials.get({ publicKey })) as PublicKeyCredential;
  return credential.toJSON();
}
